import React from "react";
const VehicleSelect = ({ vehicle, onVehicleSelect }) => {
  // console.log(vehicle);

  return (
    <ul onClick={() => onVehicleSelect(vehicle.vehicleType)}>
      <li data-vehicle-type="Comfort" className={vehicle.active && "active"}>
        <div className="car-details">
          <div className="car-img">
            <img src={vehicle.image} alt="Car" />
          </div>
          <div className="car-info">
            <div className="car-name">{vehicle.vehicleType}</div>
            <div className="car-details-pp">
              <p>
                <svg
                  role="img"
                  aria-label="Icon/Guests"
                  className="remixicon-icon"
                  width="16px"
                  height="16px"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M2 22a8 8 0 1 1 16 0H2zm8-9c-3.315 0-6-2.685-6-6s2.685-6 6-6 6 2.685 6 6-2.685 6-6 6zm7.363 2.233A7.505 7.505 0 0 1 22.983 22H20c0-2.61-1-4.986-2.637-6.767zm-2.023-2.276A7.98 7.98 0 0 0 18 7a7.964 7.964 0 0 0-1.015-3.903A5 5 0 0 1 21 8a4.999 4.999 0 0 1-5.66 4.957z" />
                </svg>
                <span>{vehicle.capacity}</span>
              </p>
              <p>
                <svg
                  role="img"
                  aria-label="Icon/Luggages"
                  className="remixicon-icon"
                  width="16px"
                  height="16px"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M15 3c.552 0 1 .448 1 1v2h5c.552 0 1 .448 1 1v13c0 .552-.448 1-1 1H3c-.552 0-1-.448-1-1V7c0-.552.448-1 1-1h5V4c0-.552.448-1 1-1h6zM8 8H6v11h2V8zm10 0h-2v11h2V8zm-4-3h-4v1h4V5z" />
                </svg>
                <span>{vehicle.luggage}</span>
              </p>
            </div>
          </div>
          <div className="car-price">
            <div className="rate" id="comfortPrice">
              AED {vehicle.fare}
            </div>
          </div>
        </div>
        <div className="car-features">{vehicle.features}</div>
        {/* <div className="product_details">
          <ul>
            <li>
              <strong>Price breakdown</strong>
            </li>
            <li>
              <strong>Rate</strong>
            </li>
            <li>Base fare</li>
            <li>580.00 AED</li>
            <li>Meet and greet</li>
            <li>580.00 AED</li>
            <li>Tax</li>
            <li>580.00 AED</li>
          </ul>
        </div> */}
      </li>
    </ul>
  );
};
export default VehicleSelect;
